<script setup>
import { ref, watchEffect } from 'vue'

const svgFiles = import.meta.glob('/src/assets/icons/*.svg', { query: '?raw', import: 'default' })

const props = defineProps({
  icon: { type: String, required: true },
  width: { type: [String, Number], default: 24 },
  height: { type: [String, Number], default: 24 },
  fill: { type: String, default: 'currentColor' },
})

const svgContent = ref('')
const svgContainer = ref(null)

watchEffect(async () => {
  if (props.icon && svgFiles[`/src/assets/icons/${props.icon}.svg`]) {
    svgContent.value = await svgFiles[`/src/assets/icons/${props.icon}.svg`]()
  }
})

watchEffect(() => {
  if (svgContainer.value && svgContent.value) {
    svgContainer.value.innerHTML = svgContent.value
  }
})
</script>

<template>
  <div v-once ref="svgContainer" class="inline-svg" :style="{ width: `${width}px`, height: `${height}px`, fill }"></div>
</template>

<style scoped>
.inline-svg :deep(svg) {
  width: inherit;
  height: inherit;
  fill: inherit;
}
</style>
